export const addRemoveFromArray = <T>(value: T, array: T[]): T[] => {
  if (array.includes(value)) {
    return array.filter((i) => i !== value);
  } else {
    return [...array, value];
  }
};
